<template>
  <v-dialog v-model="dialog" v-if="billing" max-width="500px">
    <Loading :loading="isLoading"></Loading>
    <v-btn color="info" slot="activator">Change Plan</v-btn>
    <v-card flat class="outlined" style="border-radius: 15px">
      <CardToolbar :title="$t('pageHeader.changePlan')" :isModal="true" @cancel="cancel" />
      <div class="text-xs-center mt-3">All plan changes are prorated</div>

      <v-card-text>
        <v-card v-for="plan in plans" :key="plan.id" class="ma-1 outlined" flat>
          <v-card flat class="tile pa-2" color="green" dark v-if="plan.planId === billing.basePlanId">
            <div class="text-xs-center font-weight-bold">Selected</div>
          </v-card>
          <v-card-text>
            <v-layout column>
              <v-flex>
                <h3>{{ plan.name }}</h3>
              </v-flex>
              <v-flex>
                <span class="font-weight-medium">Price:</span>
                {{
                  parseFloat(plan.amount) > 0
                    ? `${$options.filters.currency(plan.amount)}`
                    : 'Free'
                }}
              </v-flex>
              <v-flex v-if="plan.planId !== billing.basePlanId">
                <div>
                  First time subscribers receive {{ plan.trialDays }} days trial before
                  being charged. Cancel at any time!
                </div>
              </v-flex>
              <v-flex class="mt-3" v-if="plan.planId !== billing.basePlanId">
                <v-btn class="ml-0" color="info" round @click="checkPlan(plan.planId)">Pick This Plan</v-btn>
              </v-flex>
              <!-- <v-card-actions>
                <span style="color: green;" v-if="plan.planId === billing.basePlanId"
                  ><h4>Current</h4></span
                >
                <v-layout v-if="plan.planId !== billing.basePlanId" justify-center>
                  <v-flex v-if="plan.trialDays" shrink>
                    First time subscribers receive {{ plan.trialDays }} days trial before
                    being charged. Cancel at any time!
                  </v-flex>
                  <v-btn @click="changePlan(plan.planId)">Pick This Plan</v-btn>
                </v-layout>
              </v-card-actions> -->
            </v-layout>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-layout row wrap align-center>
          <v-flex shrink>
            <v-btn flat to="/marketplace">Looking to remove an add-on?</v-btn>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex>
            <v-dialog max-width="290" class="ma-2">
              <v-btn flat slot="activator">Cancel Subscription</v-btn>
              <!-- <a slot="activator" style="color: #418aca">Cancel Subscription</a> -->
              <v-card>
                <v-card-title class="headline">Cancel Account</v-card-title>
                <v-card-text>To cancel this entire subscription please email us at
                  {{ clientEmail }}. If you would like to stop charges you may switch to
                  the free plan.</v-card-text>
              </v-card>
            </v-dialog>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import locationService from '../service'
import publicService from '../../../api/public'
import Loading from '../../../components/LoadingDialog'

export default {
  name: 'location-billing-update-plan',
  props: ['location'],
  components: {
    Loading,
  },
  created() {
    publicService.GetPlans().then(response => {
      console.log('response', response)
      this.plans = response.data
    })
    this.loadBilling()
  },
  data() {
    return {
      isLoading: false,
      dialog: false,
      plans: null,
      billing: null,
      clientEmail: process.env.VUE_APP_CLIENT_EMAIL,
    }
  },
  methods: {
    cancel() {
      this.dialog = false
    },
    loadBilling() {
      locationService.Billing.getInfo(this.location.id).then(response => {
        this.billing = response.data
      })
    },
    async checkPlan(planId) {
      console.log('checkPlan', planId)
      if (planId === 'plan_GIHbR5T1dlFaX5') {
        const { value: password } = await this.$swal.fire({
          title: 'Enter Promotion Code',
          input: 'password',
          inputLabel: 'Password',
          inputPlaceholder: 'Code',
          inputAttributes: {
            maxlength: 10,
            autocapitalize: 'off',
            autocorrect: 'off',
          },
        })

        if (password === 'pak2312141') {
          this.changePlan(planId)
        } else {
          this.$swal.fire(`Invalid promotion code, please try again `)
          return false
        }
      } else {
        this.changePlan(planId)
      }
    },
    changePlan(planId) {
      this.isLoading = true
      this.$Progress.start()
      locationService.Billing.changePlan(this.location.id, { planId })
        .then(response => {
          this.dialog = false
          this.loadBilling()
          this.isLoading = false
          this.$Progress.finish()
          this.$swal
            .mixin({
              toast: true,
              position: 'top-end',
              timer: 3000,
            })
            .fire({
              icon: 'success',
              title: 'Plan was changed.',
            })

          this.$emit('updated')
        })
        .catch(error => {
          this.isLoading = false
          this.$Progress.fail()
          this.$swal
            .mixin({
              toast: true,
              position: 'top-end',
              timer: 3000,
            })
            .fire({
              icon: 'success',
              title: error.message || error.data.message,
            })

        })
    },
  },
}
</script>
